import { useNuxtApp } from '#app'

type EventCaptureProperties = {
  eventName: string
  properties?: Record<string, string>
}

/**
 * Composable for tracking events. Powered by Posthog https://posthog.com/
 */
export function useEventTracker() {
  const { $posthog } = useNuxtApp()

  /**
   * Captures an event with optional properties using PostHog
   * @param event Object containing eventName and optional properties
   */
  const capture = (event: EventCaptureProperties) => {
    if ($posthog) {
      const posthog = $posthog()
      posthog?.capture(event.eventName, event.properties)
    }
  }

  return {
    capture,
  }
}
